import React from 'react';

interface CreateModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const CreateNewsModal = ({ isOpen, onClose }: CreateModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
      <div className="bg-white p-6 rounded w-2/3 max-w-lg">
        <h2 className="text-lg font-bold mb-4">ニュースの新規作成</h2>

        <form>
          <div className="mb-4">
            <label className="block text-sm font-medium">日付</label>
            <input type="date" className="border p-2 w-full" />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium">種別</label>
            <input type="text" className="border p-2 w-full" />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium">タイトル</label>
            <input type="text" className="border p-2 w-full" />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium">URL</label>
            <input type="text" className="border p-2 w-full" />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium">表示</label>
            <div className="flex items-center">
              <input
                type="radio"
                name="display"
                value="normal"
                className="mr-2"
                defaultChecked
              />
              <label className="mr-4">通常表示</label>

              <input
                type="radio"
                name="display"
                value="fixed"
                className="mr-2"
              />
              <label>トップ固定表示</label>
            </div>
          </div>

          <div className="flex justify-between">
            <button
              type="button"
              className="border border-black rounded px-4 py-2 text-black"
              onClick={onClose}
            >
              戻る
            </button>

            <button
              type="submit"
              className="bg-green-300 text-black rounded px-4 py-2"
            >
              作成
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
